<template>
  <div 
    :class="{ 'SideBar--slim': slim }"
    class="SideBar d-flex flex-column">
    <div class="SideBar__sidemenu"></div>
    <!-- <div 
      v-if="!slim"
      class="SideBar__title d-flex pl-3 ml-3">
      <span class="align-self-center">
        MENU
      </span>
    </div>
    <SideMenu 
      class="SideBar__sidemenu"
      :items="menuItems" 
      :slim="slim" /> -->

    <Legend  
      class="SideBar__legend"
      v-if="hasLegend && !slim" />
    <div
      v-if="version && !slim"
      class="SideBar__version">
      Versie: {{ version }} 
      - 
      <router-link 
        class="text-muted" 
        :to="{name: 'logout'}">
        Uitloggen
      </router-link>
    </div>
  </div>
</template>

<script>
// import SideMenu from 'molecule/SideMenu';
import Legend from 'molecule/Legend'
import { mapGetters } from 'vuex';

export default {
  components: {
    // SideMenu, 
    Legend
  },
  props: {
    menuItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('version', [
      'version'
    ]),
    hasLegend() {
      return this.$route.meta.layout === 'map'
    }
  }
}
</script>

<style lang="scss">
.SideBar {
  position: relative;
  width: 250px;
  background: white;
  box-shadow: -1px 0px 0px 0px rgba(223,226,229,1) inset;
  user-select: none;
  color: #7F8FA4;
  max-height: 100%;

  &--slim {
    width: 50px;
    overflow: hidden;
  }

  &__title {
    height: 60px;
  }
  &__sidemenu {
    flex-grow: 1
  }
  &__version {
    // position: absolute;
    margin-bottom: 1rem;
    margin-left: 1rem;
  }
}
</style>
